import { DocumentReaderApi, Scenario } from "@regulaforensics/document-reader-webclient";

export async function regulaScanDocument(images: ArrayBuffer[]) {
    const url = `${import.meta.env.VITE_DOC_READER_API}`;

    try {
        const api = new DocumentReaderApi({ basePath: url });
        const result = await api.process({
            images: [...images],
            processParam: { scenario: Scenario.FULL_PROCESS },
        });

        return result;
    } catch (e) {
        console.error("error send documents", e);
    }
}

export default regulaScanDocument;
